/**
 * Form options for select fields.
 * Fetches data from Firestore collections.
 */

import { getFormOptions } from "@/lib/api";
import type { FormOption } from "@/types";

/**
 * Fetch agent types from Firestore
 */
export async function getAgentTypes(): Promise<FormOption[]> {
  return getFormOptions("agentTypes");
}

/**
 * Fetch providers from Firestore
 */
export async function getProviders(): Promise<FormOption[]> {
  return getFormOptions("providers");
}

/**
 * Fetch models from Firestore
 */
export async function getModels(): Promise<FormOption[]> {
  return getFormOptions("models");
}

/**
 * Fetch voices from Firestore
 */
export async function getVoices(): Promise<FormOption[]> {
  return getFormOptions("voices");
}

/**
 * Fetch transcription providers from Firestore
 */
export async function getTranscriptionProviders(): Promise<FormOption[]> {
  return getFormOptions("transcriptionProviders");
}

/**
 * Fetch languages from Firestore
 */
export async function getLanguages(): Promise<FormOption[]> {
  return getFormOptions("languages");
}

/**
 * Fetch the catalog of installable integration types from Firestore
 */
export async function getIntegrationTypes(): Promise<FormOption[]> {
  return getFormOptions("integrations");
}

/**
 * Fetch the catalog of reusable agent configuration templates (DRA-274)
 */
export async function getAgentBlueprints(): Promise<FormOption[]> {
  return getFormOptions("agentBlueprints");
}

/**
 * Helper to convert FormOption[] to { value, label }[] format for Select components
 */
export function formatOptionsForSelect(
  options: FormOption[]
): { value: string; label: string }[] {
  return options.map((opt) => ({
    value: opt.value,
    label: opt.label,
  }));
}
